import BigNumber from "bignumber.js";
import { BASE18 } from "src/configs/constance";
import { getCurrentContractAddresses } from "src/configs/address";
import ABI from "src/contract-logic/abis/NFTItemMarketplaceABI.json";
import { handleEmit } from "src/contract-logic/logic";
import { getWeb3Sender, web3Reader } from "src/wallet-connection";

const { NFT_TICKET_MARKETPLACE } = getCurrentContractAddresses();
var contractReader = null;
var contractSender = null;

function getContractReader() {
  if (!contractReader) {
    contractReader = new web3Reader.eth.Contract(ABI, NFT_TICKET_MARKETPLACE);
  }
  return contractReader;
}

function getContractSender() {
  const web3Sender = getWeb3Sender();
  if (!contractSender) {
    contractSender = new web3Sender.eth.Contract(ABI, NFT_TICKET_MARKETPLACE);
  }
  return contractSender;
}

async function getAllTicketSellOrderCount() {
  const res = await getContractReader().methods.getAllSellOrderCount().call();
  return parseInt(res);
}

async function getAllSellOrderAtIndex(index) {
  const res = await getContractReader().methods.getAllSellOrderAtIndex(index).call();
  return parseInt(res);
}

async function getSellOrderInfo(sellorder) {
  const res = await getContractReader().methods.getSellOrderInfo(sellorder).call();
  return res;
}

async function makeBuyOrder(dispatch, orderId, quantity, accountAddress) {
  const emit = getContractSender().methods.makeOrder(orderId, quantity).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Buy Ticket");
  return await emit;
}

async function createSale(dispatch, tokenId, amount, price, paymentOption, sponsorSlot, duration, accountAddress) {
  const emit = getContractSender()
    .methods.createSale(tokenId, amount, price, paymentOption, sponsorSlot, duration)
    .send({ from: accountAddress });
  handleEmit(dispatch, emit, "Sell Ticket");
  return await emit;
}

async function cancelSale(dispatch, orderId, accountAddress) {
  const emit = getContractSender().methods.cancelSale(orderId).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Cancel Ticket");
  return await emit;
}

async function getSellOrderCount(owner) {
  const res = await getContractReader().methods.getSellOrderCount(owner).call();
  return parseInt(res);
}

async function getSlotCount() {
  const res = await getContractReader().methods.slotCount().call();
  return parseInt(res);
}

async function isSponsorSlotOccupied(slot) {
  const res = await getContractReader().methods.isSponsorSlotOccupied(slot).call();
  return res;
}

async function getSlotInfo(sponsorQueue) {
  const res = await getContractReader().methods.getSponsorQueueInfo(sponsorQueue).call();
  return res;
}

async function getSlotRentPricePerHour() {
  const res = await getContractReader().methods.slotRentPricePerHour().call();
  return BigNumber(res).dividedBy(BASE18).toNumber();
}

async function rentSlot(dispatch, orderId, duration, accountAddress) {
  let slot = 0;
  const maxSlot = await getSlotCount();
  const promises = new Array(maxSlot).fill(1).map((value, index) => {
    return new Promise((resolve) => resolve(isSponsorSlotOccupied(index + 1)));
  });

  const newPromises = promises.map(
    (p, index) => new Promise((resolve, reject) => p.then((v) => !v && resolve(index + 1), reject))
  );
  newPromises.push(Promise.all(promises).then(() => 0));
  slot = await Promise.race(newPromises);

  if (slot == 0) {
    throw new Error("No available input, please reload page to update");
  }

  const emit = getContractSender().methods.rentSlot(orderId, slot, duration).send({ from: accountAddress });
  handleEmit(dispatch, emit, "Rent Slot");
  await emit;
  return slot;
}

export default {
  ABI,
  ADDRESS: NFT_TICKET_MARKETPLACE,
  getAllTicketSellOrderCount,
  getAllSellOrderAtIndex,
  getSellOrderInfo,
  makeBuyOrder,
  createSale,
  getSellOrderCount,
  cancelSale,
  getSlotCount,
  getSlotRentPricePerHour,
  rentSlot,
  isSponsorSlotOccupied,
  getSlotInfo,
};
